import React from 'react';
import { Col } from 'antd';
export const ChatMessage = (props)=> {
  const { message, children  } = props;

  const renderContentElement = ()=> {
    return children(message, {
      container: {}
    });
  };
  return (
    <Col className="message-balloon-container">
      {renderContentElement()}
    </Col>
  );
};
